<template>
  <div class="leader-tile">
    <a :href="data.linkedin" class="leader-text" target="_blank">
        <div class="leader-headshot">
            <img :src="imageSrc" :alt="data.name" class="leader-image" loading="lazy" decoding="async"/>
        </div>
    <p class="name"><b>{{ data.name }}</b></p>
    <p class="pronouns"><i>({{ data.pronouns }})</i></p>
    <p class="position">{{ data.position }}</p>
    </a>
</div>
</template>

<script>
export default {
    name: "LeaderTile",
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        imageSrc() {
            if (!this.data.image) return '';
            const img = this.data.image.trim();
            if (/^(https?:|\/|data:)/i.test(img)) {
                return img;
            }
            if (img.startsWith('headshots/')) {
                return `/${img}`;
            }
            return `/headshots/${img}`;
        }
    }
}
</script>

<style lang="scss">
.leader-tile{
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    width: 7em;
    //width: fit-content;
    
    .leader-text{
        // text-align: center;
        text-decoration: none;
        color: var(--medium);
        
        .leader-headshot{
            background-color: var(--dark);
            width: 7rem;
            height: 7rem;
            overflow: hidden;
            border-radius: var(--border-radius-full);
    
            .leader-image{
                width: 100%;
                // height: 100%;
                background-size: auto;
                background-position: center;
                transition: transform var(--transition-fast); // Smooth animation on hover      
            }
        }
        .name{
            margin-bottom: 0;
        }
        
        .pronouns{
            margin-top: .5em;
            margin-bottom: 0;
            color: var(--text-muted);
        }
        
        .position{
            margin-top: .5em;
            // flex-wrap: wrap;
        }
        
        &:hover{
            cursor: pointer;
            .leader-image{
                transform: scale(1.1);
            }
            .name {
                text-decoration: underline;
            }
        }

        &:focus {
            outline: 2px dashed var(--regular);
            outline-offset: 4px;
            border-radius: var(--border-radius-md);
        }
    }
}

@media screen and (max-width: 768px) {
  .leader-tile {
    width: 5.5rem;

    .leader-text {
      .leader-headshot {
        width: 4.5rem;
        height: 4.5rem;
        margin: 0 auto;
      }

      .name {
        font-size: 0.8rem;
        line-height: 1.2;
        margin-top: 0.35rem;
        margin-bottom: 0;
      }

      .pronouns {
        font-size: 0.68rem;
        line-height: 1.1;
        margin-top: 0.15rem;
        margin-bottom: 0;
        color: var(--text-muted);
      }

      .position {
        font-size: 0.72rem;
        line-height: 1.2;
        margin-top: 0.2rem;
      }
    }
  }
}
</style>